<template>
  <ValidationProvider :tag="tag" :name="$attrs.name" :rules="rules" v-slot="{ errors }">
    <v-text-field
      v-model="innerValue"
      :error-messages="errors"
      v-bind="$attrs"
      v-on="$listeners"
    >
      <template #prepend-inner>
        <slot name="prepend-inner" />
      </template>
      <template #append-outer>
        <slot name="append-outer" />
      </template>
    </v-text-field>
  </ValidationProvider>
</template>

<script>
import { ValidationProvider } from 'vee-validate';

export default {
  name: 'TextField',

  components: {
    ValidationProvider,
  },

  props: {
    rules: {
      type: [Object, String],
      default: '',
    },

    tag: {
      type: String,
      default: 'span',
    },

    // must be included in props
    value: {
      type: null,
    },
  },

  data: () => ({
    innerValue: '',
  }),

  watch: {
    innerValue (newVal) {
      this.$emit('input', newVal);
    },

    value (newVal) {
      this.innerValue = newVal;
    },
  },

  created () {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
};
</script>
